
export * from '../../frontend-js-dependencies-web/__liferay__/exports/object-hash.js';

import __default__ from '../../frontend-js-dependencies-web/__liferay__/exports/object-hash.js';
export default __default__;
